import { render, staticRenderFns } from "./NuclearMagneticResonanceViz.vue?vue&type=template&id=315e795f&scoped=true"
import script from "./NuclearMagneticResonanceViz.vue?vue&type=script&lang=js"
export * from "./NuclearMagneticResonanceViz.vue?vue&type=script&lang=js"
import style0 from "./NuclearMagneticResonanceViz.vue?vue&type=style&index=0&id=315e795f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e795f",
  null
  
)

export default component.exports